// @flow
import React, { useRef } from 'react';

type Props = {
  label: string,
  onFiles: (files: Array<File>) => void,
  className?: string,
};

// Кнопка выбора папки: браузер отдаёт все файлы внутри, в том числе из
// вложенных папок, с путями в webkitRelativePath
export default function FolderPickButton({ label, onFiles, className }: Props) {
  const input = useRef(null);
  return (
    <>
      <button
        type="button"
        className={className || 'btn btn-outline-primary btn-sm'}
        onClick={() => input.current && input.current.click()}
      >
        {label}
      </button>
      <input
        ref={input}
        type="file"
        webkitdirectory=""
        directory=""
        multiple
        style={{ display: 'none' }}
        onChange={e => {
          const files = Array.from(e.target.files || []);
          e.target.value = ''; // та же папка ещё раз — снова событие
          if (files.length) onFiles(files);
        }}
      />
    </>
  );
}
